// MISC
export const TIME_LIMIT_FOR_FETCH = 1200000
export const TIME_LIMIT_FOR_FETCH_12HR = 43200000

export const winloc = window.location

// ENVIRONMENT
// export const is_local_host = winloc.hostname.indexOf('localhost') >= 0 || winloc.hostname.indexOf('192.168.') >= 0 ? true : false
export const is_local_host = winloc.hostname.indexOf('portal') < 0 ? true : false

export const is_test_env = winloc.hostname.indexOf('portal.test.farmdeck.com') >= 0 ? true : false
/** Strictly the production host. Unlike `is_prod_env` this is not true for native builds. */
export const is_prod_host = winloc.hostname.indexOf('portal.farmdeck.com') >= 0
export const is_mobile_build = process.env.REACT_APP_BUILD_MODE === 'android' || process.env.REACT_APP_BUILD_MODE === 'ios'
export const is_prod_env = winloc.hostname.indexOf('portal.farmdeck.com') >= 0 ? true : is_test_env && is_mobile_build ? false : is_mobile_build ? true : false
export const is_development = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? true : false
/** Full-site maintenance screen in index.js; enable with REACT_APP_MAINTENANCE_MODE=true or 1 at build time */
export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true' || process.env.REACT_APP_MAINTENANCE_MODE === '1'
export const FARMDECK_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/:id/api/v1/`
export const IS_HTTPS = winloc.protocol === 'https:' ? true : false
export const ENVPRE = is_local_host ? 'fmd.local.' : is_test_env ? 'fmd.test.' : is_prod_env ? 'fmd.prod.' : 'fmd.env.'

// GOOGLE
export const GOOGLE_API = is_local_host || is_test_env ? (winloc.port === '3011' ? 'AIzaSyD0XBtqanFBzm_FKfWTw-M8oqF-gyb6-Ys' : 'AIzaSyBCoKfZ8uGm5gN95X6f4_sP8N3ICG0uhK0') : 'AIzaSyDKabILSDS5Fgbh_3VTZ2WtHinW4bCAySs'
// Pin the Maps JS API version. DrawingManager was REMOVED as of v3.65, which breaks
// the custom drawing toolbar (new paddock/asset shapes). 3.64 is the last version that
// still ships it. STOPGAP — drawing.js must be reimplemented without DrawingManager
// before 3.64 is retired, after which this pin can be dropped. Whichever map loader
// runs first sets the shared script's version, so every loader must use this constant.
export const GOOGLE_MAPS_VERSION = '3.64'
export const GOOGLE_MAP_ID = is_local_host || is_test_env ? '8559ad56f1027565' : '24f291a687ff7f1378b79876'
export const GOOGLE_STATIC = 'https://maps.googleapis.com/maps/api/staticmap?'
export const GOOGLE_STREETVIEW = 'https://maps.googleapis.com/maps/api/streetview?'

// MAPS
export const ARCGIS_ENABLED = false
export const ARCGIS_KOOP_API = `http://localhost:8080/farmdeck`

// WEATHER
export const BOM_WEATHER_API = is_local_host ? 'https://api.test.farmdeck.com/internal/bom/image/' : 'https://api.farmdeck.com/internal/bom/image/'

export const WEATHER_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/openweather?lat,lng&exclude=minutely`

export const IP_ADDRESS_API = 'https://still-river-42055.herokuapp.com/ipstack'

// AWS / COGNITO
export const AWSCOGNITO_USERPOOLID = is_local_host || is_test_env ? 'ap-southeast-2_CAQv4NxWJ' : 'ap-southeast-2_Tsc3e4QGs'
export const AWSCOGNITO_CLIENTID = is_local_host || is_test_env ? '5ofqcu33p1q30iu9ligb19sqkb' : '3dujq75012o9l15acbgl36k805'
export const AWSCOGNITO_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/api/v1/tenants/`
// PAYMENTS
export const PAYMENTS_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/payments/api/v1/customers/:id`
export const GISSERVICE_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/gisservice/api/v1/readings/:tenantID`
export const STRIPE_PUBLISHABLE_KEY = !is_local_host && is_prod_env ? 'pk_live_toCmF9VgqGAtfDfYDljxw00C0006fREBnh' : is_local_host || is_test_env ? 'pk_test_8WLcjRjQVzg91Srcf4Nqndvv00AMv1NOCb' : ''

// VIDEO SURVEILLANCE
export const VIDEO_SURVEILLANCE_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/videosurveillance/api/v1/:id`

// PLANNER / TASKMANAGER
export const PLANNER_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/planner/api/v1/:tenantID`

export const TASKMANAGER_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/taskmanagerv2/api/v1/:id`

// export const TASKMANAGER_API = `http://localhost:3000/api/v1/:id`

export const RESOURCE_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/resource/:id`

export const FIREBASE_PROXY_API = `https://api${!is_local_host && is_prod_env ? '' : is_local_host || is_test_env ? '.test' : ''}.farmdeck.com/internal/firebase/api/v1`

export const FIREBASE_CONFIG =
    is_local_host || is_test_env
        ? {
              apiKey: 'AIzaSyDxZihgRSSt5TUnoUV6nnBhbr4X8AIcMkA',
              authDomain: 'farmdeck-test-app.firebaseapp.com',
              databaseURL: 'https://farmdeck-test-app.firebaseio.com',
              projectId: 'farmdeck-test-app',
              storageBucket: 'farmdeck-test-app.appspot.com',
              messagingSenderId: '60814131809',
              appId: '1:60814131809:web:f35781e05e71e5fe46e020',
          }
        : {
              apiKey: 'AIzaSyAHKzCFwf_67We-pb98ntF8ZyQb9sR1O-4',
              authDomain: 'farmdeck-app.firebaseapp.com',
              databaseURL: 'https://farmdeck-app.firebaseio.com',
              projectId: 'farmdeck-app',
              storageBucket: 'farmdeck-app.appspot.com',
              messagingSenderId: '503284347016',
              appId: '1:503284347016:web:14ed2904e9e0770af5af3d',
              measurementId: 'G-R0L59E6RND',
          }

export const FIREBASE_VAPID_KEY = is_local_host || is_test_env ? 'BGsE_j9eFlK3ShXNPWkbhip3SR_58CZmbQnzjtY-9SZDlnGXA1SSpXNNQTWjUSnzBvH8DuYtROZS-AlmvQ22zRw' : 'BD4iBGdpNinIH62qJ8WpUPt0gOYvmdN9bhS3ALlEA_Q5y-2IuLg42BzrHqk5Y175UM5kGQdOdgFsuWrW0ROpDSg'
